import { render } from "./add-to-cart.vue?vue&type=template&id=92ecc952"
import script from "./add-to-cart.vue?vue&type=script&lang=js"
export * from "./add-to-cart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__